
export const SET_CONVERSATION_MASTER = 'SET_CONVERSATION_MASTER';

export const SET_ORGANISER_MASTER = 'SET_ORGANISER_MASTER';

